package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * An image the user picked from their device, ready to upload. Carries the raw [bytes] plus the
 * [mimeType] (e.g. `image/jpeg`) so Storage can set the right content type. Produced by the
 * platform image picker injected at the app entry point.
 */
class PickedImage(val bytes: ByteArray, val mimeType: String) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is PickedImage) return false
        return mimeType == other.mimeType && bytes.contentEquals(other.bytes)
    }

    override fun hashCode(): Int = 31 * bytes.contentHashCode() + mimeType.hashCode()
}
